import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

import meteringDeviceStatusMock from './meteringDeviceStatusMock.json';

const mock = new AxiosMockAdapter(instance, { delayResponse: 500 });

mock
  .onGet(/metering-device-statuses/)
  .reply(200, meteringDeviceStatusMock)
  .onAny()
  .passThrough();
